module.exports = __webpack_public_path__ + "9d833df2c21cf615cde0fc35cedbe22d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/eyes.png
// module id = muTR
// module chunks = 0